import { Route, Routes } from "react-router-dom";
import ProtectedRoutes from "routes/ProtectedRoutes";
import { authRoutes, protectedRoutes } from "routes/constant";
import RedirectHandler from "routes/RedirectHandler";

const Router = () => {
  return (
    <RedirectHandler>
      <Routes>
        {authRoutes.map((route) => (
          <Route
            key={route.title}
            path={route.path}
            element={route.component}
            title={route.title}
          />
        ))}
        <Route element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => (
            <Route
              key={route.title}
              path={route.path}
              element={route.component}
              title={route.title}
            />
          ))}
        </Route>
      </Routes>
    </RedirectHandler>
  );
};

export default Router;
